module.exports = {
      id: "comm-vikatan-plus-usage",
      viewBox: "0 0 484.569 52.881",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-vikatan-plus",
      toString: function () {
        return this.url;
      }
    }